export default __webpack_public_path__ + "static/media/unnamed.1d99acce.jpg";